// extracted by mini-css-extract-plugin
export default {"wrap":"_m_7j","current":"_Rwuu","button":"H9hw6","price-box":"_o_lp","description":"K5k_V","trial-label":"nTptT","popular-label":"_eJwZ","popular":"tcslm","unavailable":"zzPWX"};